
import {
    ACTIVATE_ACTION_TYPE,
    CREATE_ACCOUNT_ACTION_TYPE,
    CHANGE_PASSWORD_ACTION_TYPE,
    EDIT_ACCOUNT_ACTION_TYPE,
    LOGIN_ACTION_TYPE,
    LOGOUT_ACTION_TYPE,
    RESET_PASSWORD_ACTION_TYPE,
    RESET_PASSWORD_REQUEST_ACTION_TYPE,
} from '../sagas/auth';

const initialState = {
    data: null,
    loading: false,
    operationLoading: false,
    loginFailed: false,
    loginError: null,
    createAccountFailed: false,
    resetPasswordRequestSend: false,
};

function activate(state, action) {
    if (action.data.success) {
        return {
            ...state,
            data: {
                ...state.data,
                user: {
                    ...state.data.user,
                    activated: 1
                }
            }
        }
    } else {
        return state;
    }
}

function editAccount(state, action) {
    if (action.data.success) {
        return {
            ...state,
            data: {
                ...state.data,
                user: {
                    ...state.data.user,
                    params: {
                        ...state.data.user.params,
                        email: action.params.email,
                        fullName: action.params.fullName
                    }
                }
            }
        }
    } else {
        return state;
    }
}

function operationLoadingEnd(state, action) {
    return {
        ...state,
        operationLoading: false
    };
}

function operationLoadingStart(state, action) {
    return {
        ...state,
        operationLoading: true
    };
}

function resetPasswordRequest(state, action) {
    if (action.data.success) {
        return {
            ...state,
            operationLoading: false,
            resetPasswordRequestSend: true
        };
    } else {
        return {
            ...state,
            operationLoading: false,
        };
    }
}

export default function auth(state = initialState, action) {
    switch (action.type) {
        case CREATE_ACCOUNT_ACTION_TYPE.DEFAULT:
        case LOGIN_ACTION_TYPE.DEFAULT:
            return {
                ...state,
                data: null,
                loading: true,
                loginFailed: false,
                loginError: null,
                createAccountFailed: false,
                resetPasswordRequestSend: false,
            };

        case CREATE_ACCOUNT_ACTION_TYPE.SUCCESS:
        case LOGIN_ACTION_TYPE.SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.data
            };

        case CREATE_ACCOUNT_ACTION_TYPE.FAILED:
            return {
                ...state,
                data: null,
                loading: false,
                createAccountFailed: true
            };

        case LOGIN_ACTION_TYPE.FAILED:
            return {
                ...state,
                data: null,
                loading: false,
                loginFailed: true,
                loginError: action.error
            };

        case LOGOUT_ACTION_TYPE.SUCCESS:
            return {
                ...initialState
            };

        case ACTIVATE_ACTION_TYPE.SUCCESS: {
            return activate(state, action);
        }

        case CHANGE_PASSWORD_ACTION_TYPE.LOADING: {
            return operationLoadingStart(state, action);
        }

        case CHANGE_PASSWORD_ACTION_TYPE.SUCCESS: {
            return operationLoadingEnd(state, action);
        }

        case EDIT_ACCOUNT_ACTION_TYPE.SUCCESS: {
            return editAccount(state, action);
        }

        case RESET_PASSWORD_REQUEST_ACTION_TYPE.DEFAULT: {
            return {
                ...state,
                resetPasswordRequestSend: false
            };
        }

        case RESET_PASSWORD_REQUEST_ACTION_TYPE.LOADING: {
            return operationLoadingStart(state, action);
        }

        case RESET_PASSWORD_REQUEST_ACTION_TYPE.SUCCESS: {
            return resetPasswordRequest(state, action);
        }

        case RESET_PASSWORD_ACTION_TYPE.LOADING: {
            return operationLoadingStart(state, action);
        }

        case RESET_PASSWORD_ACTION_TYPE.SUCCESS: {
            return operationLoadingEnd(state, action);
        }

        default:
            return state
    }
}
